const { createImage, duplicateImage } = require('./Image');

const baseTrait = {
  _version: 2,
  type: 0,
  displayName: '',
  description: '',
  low: '',
  high: '',
  value: 0.5,
  image: createImage(),
};

const createTrait = (overrides = {}) => ({
  ...baseTrait,
  ...overrides
});

const duplicateTrait = trait => ({
  ...trait,
  image: duplicateImage(trait.image)
});

// TODO Figure out how to combine this with player-generator
const createDefaultTraits = () => {
  return [
    createTrait({
      displayName: 'Peaceful/Aggressive',
      low: 'Peaceful',
      high: 'Aggressive',
      type: 0,
      value: 0
    }),
    createTrait({
      displayName: 'Introverted/Extraverted',
      low: 'Introverted',
      high: 'Extraverted',
      type: 1,
      value: 0
    }),
    createTrait({
      displayName: 'Technical/Artistic',
      low: 'Technical',
      high: 'Artistic',
      type: 2,
      value: 0
    }),
    createTrait({
      displayName: 'Responsible/Adventurous',
      low: 'Responsible',
      high: 'Adventurous',
      type: 3,
      value: 0
    })
  ];
}

module.exports = {
  createTrait,
  duplicateTrait,
  createDefaultTraits
};
